
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "b87b43637d4f3e57c6617cda6fcf243f88dfe0de",
  "nuxt": {
    "buildId": "db320f27-36bf-48aa-a1ce-42f8a5313a14"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
